import PropTypes from 'prop-types';
import FilePreview from './FilePreview';

export function FileUrlPreview(
  {
    file,
    name,
    type,
    ...props
  }
) {
  return (
    <FilePreview
      {...props}
      file={{
        type,
        name,
        fileKey: file
      }}
    />
  );
}

FileUrlPreview.propTypes = {
  file: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  props: PropTypes.any
};

export default FileUrlPreview;
